<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisField from 'dashboard/components-next/LaisField.vue';

const props = defineProps({
  title: { type: String, required: true },
  enabledLabel: { type: String, required: true },
  businessHoursLabel: { type: String, required: true },
  mode: {
    type: String,
    required: true,
    validator: value => ['rent', 'sale'].includes(value),
  },
});

const model = defineModel({
  type: Object,
  required: true,
});

const inputClass =
  'w-full rounded-lais border border-lais-border px-3 py-2 text-[14px] bg-white';
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisCard :title="title">
    <label class="mb-3 flex items-center gap-2 text-[13px]">
      <input v-model="model.enabled" type="checkbox" />
      {{ enabledLabel }}
    </label>
    <div v-if="model.enabled" class="grid gap-3 md:grid-cols-2">
      <LaisField :label="businessHoursLabel">
        <input v-model="model.business_hours" :class="inputClass" />
      </LaisField>
      <LaisField label="Documentos exigidos">
        <input v-model="model.required_documents" :class="inputClass" />
      </LaisField>
      <LaisField v-if="props.mode === 'rent'" label="Garantias aceitas">
        <input v-model="model.guarantees" :class="inputClass" />
      </LaisField>
      <LaisField
        v-if="props.mode === 'sale'"
        label="Financiamento (simulação/bancos/prazo)"
      >
        <input v-model="model.financing" :class="inputClass" />
      </LaisField>
      <LaisField
        :label="props.mode === 'rent' ? 'Prazo de análise' : 'Prazo médio'"
      >
        <input v-model="model.analysis_deadline" :class="inputClass" />
      </LaisField>
      <LaisField v-if="props.mode === 'rent'" label="Multas/prazos">
        <input v-model="model.penalties" :class="inputClass" />
      </LaisField>
      <LaisField label="Nomenclatura do corretor">
        <input v-model="model.agent_naming" :class="inputClass" />
      </LaisField>
    </div>
  </LaisCard>
</template>
